<template>
    <div class="card noselect card-img-holder text-white" @click="openSeries"
         @mouseenter="hovered = true" @mouseleave="hovered = false"
         :class="[hovered ? 'shadow-lg bg-primary' : 'shadow-sm bg-dark', linkEnabled ? 'cursor-pointer' : '', hoverEnabled ? 'card-hover' : '']">
        <img :src="series.thumbnail_url" class="card-img-top" :alt="series.title[$i18n.locale]" @load="imageLoaded = true" v-show="imageLoaded">

        <!-- Loading indicator if image is not loaded -->
        <div class="text-center bg-light" v-if="!imageLoaded" style="padding-top: 80px; padding-bottom: 80px;">
            <i class="mdi mdi-spin mdi-autorenew mdi-36px text-primary"></i>
        </div>

        <div class="card-body">
            <img src="/images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image">
            <h2 class="mb-3">
                {{ series.title[$i18n.locale] }}
            </h2>
            <p v-if="series.description !== null">
                {{ series.description[$i18n.locale] }}
            </p>
            <h5 class="font-weight-lighter mb-3">
                {{ $t('pages.series.card.video_count', {count: series.video_count}) }}
            </h5>
        </div>
<!--        <div class="card-footer pl-4 pr-4">-->
<!--            <i class="float-right font-weight-lighter align-text-bottom">-->
<!--                {{ $t('pages.series.card.last_update_at', {last_update: $date(series.updated_at).fromNow()}) }}-->
<!--            </i>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    name: "SeriesCard",
    props: {
        series: {
            type: Object,
            required: true
        },
        linkEnabled: {
            type: Boolean,
            default: true
        },
        hoverEnabled: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        hovered: false,
        imageLoaded: false,
    }),
    methods: {
        openSeries() {
            if(!this.linkEnabled)
                return false;

            this.$router.push({name: 'series.show', params: {slug: this.series.slug}});
        }
    }
}
</script>

<style scoped>
    .card-img-top {
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
    .card {
        transition: transform 0.5s;
        transform: scale(1);
    }
    .card-hover:hover {
        transition: transform 0.5s;
        transform: scale(1.04);
        z-index: 999;
    }

    .card.card-img-holder .card-img-absolute {
        right: -4px;
    }
</style>
